import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function Images() {
// default image parallax
    gsap.utils.toArray(".parallax-wrapper .parallax-content").forEach((section, i) => {
    const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;

    gsap.fromTo(section,{ 
        y: -heightDiff
    }, {
        scrollTrigger: {
            trigger: section.parentElement,
            scrub: true,
            invalidateOnRefresh : true,
        },
            y: 0,
            ease: "none"
        });
    });

    try {
        gsap.utils.toArray('.reveal-image').forEach((el, i) => {
          const tl_universal = gsap.timeline({
            scrollTrigger: {
              trigger: el
            }
          });
    
          tl_universal.set(
            el, {
              autoAlpha: 1
            });
    
          tl_universal.fromTo(el, {
              clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)"
            }, {
              clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
            });
        });
    } catch (error) {}
}
